import { IRequestedStudy } from '@vivli/features/data-requests/infrastructure/interface';
import { CSSProperties } from 'react';
import { Color } from '@vivli/shared/theme';

const sectionStyle: CSSProperties = {
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingLeft: 0,
    paddingRight: 0,
    display: 'flex',
    flexDirection: 'row',
    paddingBottom: 10,
    paddingTop: 0,
};

const studyRowStyle: CSSProperties = {
    display: 'grid',
    gridAutoFlow: 'row',
    paddingBottom: 0,
    paddingTop: 0,
    color: Color.VIVLI_PUBLISHED_DARKBLUE,
    whiteSpace: 'pre-wrap',
};

interface PublishingRequestedStudyRowComponentProps {
    requestedStudy?: IRequestedStudy;
    index: number;
    isConfigMode: boolean;
    fieldName?: string;
}

export const PublishingRequestedStudyRowComponent = ({
    requestedStudy,
    index,
    isConfigMode,
    fieldName,
}: PublishingRequestedStudyRowComponentProps) => {
    const displayStudy = isConfigMode || requestedStudy?.publishable;

    const nctId = requestedStudy?.nctId;
    const sponsorProtocolId = requestedStudy?.sponsorProtocolId;
    const orgName = requestedStudy?.organizationName;
    const studyTitle = requestedStudy?.studyTitle;
    const vivliStudyDoi = requestedStudy?.vivliStudyDoi;
    const showNctId = nctId && nctId !== 'false' && nctId.length > 0;

    return (
        <div style={sectionStyle}>
            {displayStudy && (
                <div style={studyRowStyle}>
                    <div>
                        <a href={vivliStudyDoi} target="_blank">
                            {studyTitle}
                        </a>
                    </div>

                    <div style={studyRowStyle}>Sponsor: {orgName}</div>
                    {showNctId && <div style={studyRowStyle}>Study ID: {nctId}</div>}
                    <div style={studyRowStyle}>Sponsor ID: {sponsorProtocolId}</div>
                </div>
            )}
        </div>
    );
};
